import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "42.133",
      cy: "7",
      r: "6.933",
      fill: "#FF3636",
      opacity: ".2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF3636",
      d: "m.533 7 6.19 3.574V3.426zm5.572.619h36.028V6.381H6.105z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42.133",
      cy: "7",
      r: "4.003",
      fill: "#FF3636",
      stroke: "#FF3636",
      "stroke-width": "1.238"
    }, null, -1)
  ]))]))
}
export default { render: render }